"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEADER_CARD_MANIFEST = void 0;
const CardName_1 = require("../../CardName");
const GameModule_1 = require("../../GameModule");
const CardManifest_1 = require("../CardManifest");
const Apollo_1 = require("./Apollo");
const Asimov_1 = require("./Asimov");
const Bjorn_1 = require("./Bjorn");
const Buck_1 = require("./Buck");
const Caesar_1 = require("./Caesar");
const Clarke_1 = require("./Clarke");
const Darwin_1 = require("./Darwin");
const Duncan_1 = require("./Duncan");
const Ender_1 = require("./Ender");
const Eunice_1 = require("./Eunice");
const Faraday_1 = require("./Faraday");
const Floyd_1 = require("./Floyd");
const Gaia_1 = require("./Gaia");
const Gordon_1 = require("./Gordon");
const Greta_1 = require("./Greta");
const HAL9000_1 = require("./HAL9000");
const Huan_1 = require("./Huan");
const Ingrid_1 = require("./Ingrid");
const Jane_1 = require("./Jane");
const Jansson_1 = require("./Jansson");
const Karen_1 = require("./Karen");
const Lowell_1 = require("./Lowell");
const Maria_1 = require("./Maria");
const Musk_1 = require("./Musk");
const Naomi_1 = require("./Naomi");
const Neil_1 = require("./Neil");
const Oscar_1 = require("./Oscar");
const Petra_1 = require("./Petra");
const PublicGrants_1 = require("./PublicGrants");
const Quill_1 = require("./Quill");
const Rogers_1 = require("./Rogers");
const Ryu_1 = require("./Ryu");
const Stefan_1 = require("./Stefan");
const Tate_1 = require("./Tate");
const Ulrich_1 = require("./Ulrich");
const VanAllen_1 = require("./VanAllen");
const Will_1 = require("./Will");
const Xavier_1 = require("./Xavier");
const Xu_1 = require("./Xu");
const Yvonne_1 = require("./Yvonne");
const Zan_1 = require("./Zan");
exports.LEADER_CARD_MANIFEST = new CardManifest_1.CardManifest({
    module: GameModule_1.GameModule.Leader,
    leaderCards: [
        { cardName: CardName_1.CardName.APOLLO, Factory: Apollo_1.Apollo, compatibility: GameModule_1.GameModule.Moon },
        { cardName: CardName_1.CardName.ASIMOV, Factory: Asimov_1.Asimov },
        { cardName: CardName_1.CardName.BJORN, Factory: Bjorn_1.Bjorn },
        { cardName: CardName_1.CardName.BUCK, Factory: Buck_1.Buck },
        { cardName: CardName_1.CardName.CAESAR, Factory: Caesar_1.Caesar, compatibility: GameModule_1.GameModule.Ares },
        { cardName: CardName_1.CardName.CLARKE, Factory: Clarke_1.Clarke },
        { cardName: CardName_1.CardName.DARWIN, Factory: Darwin_1.Darwin, compatibility: GameModule_1.GameModule.Turmoil },
        { cardName: CardName_1.CardName.DUNCAN, Factory: Duncan_1.Duncan },
        { cardName: CardName_1.CardName.ENDER, Factory: Ender_1.Ender },
        { cardName: CardName_1.CardName.EUNICE, Factory: Eunice_1.Eunice, compatibility: GameModule_1.GameModule.Prelude },
        { cardName: CardName_1.CardName.FARADAY, Factory: Faraday_1.Faraday },
        { cardName: CardName_1.CardName.FLOYD, Factory: Floyd_1.Floyd },
        { cardName: CardName_1.CardName.GAIA, Factory: Gaia_1.Gaia, compatibility: GameModule_1.GameModule.Ares },
        { cardName: CardName_1.CardName.GORDON, Factory: Gordon_1.Gordon },
        { cardName: CardName_1.CardName.GRETA, Factory: Greta_1.Greta },
        { cardName: CardName_1.CardName.HAL9000, Factory: HAL9000_1.HAL9000 },
        { cardName: CardName_1.CardName.HUAN, Factory: Huan_1.Huan, compatibility: GameModule_1.GameModule.Colonies },
        { cardName: CardName_1.CardName.INGRID, Factory: Ingrid_1.Ingrid },
        { cardName: CardName_1.CardName.JANE, Factory: Jane_1.Jane },
        { cardName: CardName_1.CardName.JANSSON, Factory: Jansson_1.Jansson },
        { cardName: CardName_1.CardName.KAREN, Factory: Karen_1.Karen, compatibility: GameModule_1.GameModule.Prelude },
        { cardName: CardName_1.CardName.LOWELL, Factory: Lowell_1.Lowell, compatibility: GameModule_1.GameModule.Prelude },
        { cardName: CardName_1.CardName.MARIA, Factory: Maria_1.Maria, compatibility: GameModule_1.GameModule.Colonies },
        { cardName: CardName_1.CardName.MUSK, Factory: Musk_1.Musk },
        { cardName: CardName_1.CardName.NAOMI, Factory: Naomi_1.Naomi, compatibility: GameModule_1.GameModule.Colonies },
        { cardName: CardName_1.CardName.NEIL, Factory: Neil_1.Neil, compatibility: GameModule_1.GameModule.Moon },
        { cardName: CardName_1.CardName.OSCAR, Factory: Oscar_1.Oscar, compatibility: GameModule_1.GameModule.Turmoil },
        { cardName: CardName_1.CardName.PETRA, Factory: Petra_1.Petra, compatibility: GameModule_1.GameModule.Turmoil },
        { cardName: CardName_1.CardName.PUBLIC_GRANTS, Factory: PublicGrants_1.PublicGrants },
        { cardName: CardName_1.CardName.QUILL, Factory: Quill_1.Quill, compatibility: GameModule_1.GameModule.Venus },
        { cardName: CardName_1.CardName.ROGERS, Factory: Rogers_1.Rogers, compatibility: GameModule_1.GameModule.Venus },
        { cardName: CardName_1.CardName.RYU, Factory: Ryu_1.Ryu },
        { cardName: CardName_1.CardName.STEFAN, Factory: Stefan_1.Stefan },
        { cardName: CardName_1.CardName.TATE, Factory: Tate_1.Tate },
        { cardName: CardName_1.CardName.ULRICH, Factory: Ulrich_1.Ulrich },
        { cardName: CardName_1.CardName.VAN_ALLEN, Factory: VanAllen_1.VanAllen },
        { cardName: CardName_1.CardName.WILL, Factory: Will_1.Will, compatibility: GameModule_1.GameModule.Venus },
        { cardName: CardName_1.CardName.XAVIER, Factory: Xavier_1.Xavier, compatibility: GameModule_1.GameModule.Prelude },
        { cardName: CardName_1.CardName.XU, Factory: Xu_1.Xu, compatibility: GameModule_1.GameModule.Venus },
        { cardName: CardName_1.CardName.YVONNE, Factory: Yvonne_1.Yvonne, compatibility: GameModule_1.GameModule.Colonies },
        { cardName: CardName_1.CardName.ZAN, Factory: Zan_1.Zan, compatibility: GameModule_1.GameModule.Turmoil },
    ],
    cardsToRemove: [
        CardName_1.CardName.PUBLIC_GRANTS,
    ],
});
//# sourceMappingURL=LeaderCardManifest.js.map